import Sound from "./Sound";

export default Sound;
